(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["intro-screen"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  var PLAY_TO_ARM = 1620;
  var PLAY_TO_REVEAL = 1660;

  /* Le quattro PNG pesano circa 66 KB. Normalmente rete + decode richiedono
     200-300 ms. Dopo 2200 ms VISIBILI si libera la pagina, ma non si avvia mai
     un'intro incompleta. Il secondo limite parte dal primo frame, non dal click. */
  var RESOURCE_TIMEOUT = 2200;
  var HARD_STOP_DA_PLAY = 3600;

  /* Punto B: si guarda il cliente, non quanto e' lento il nostro tema.
     Risparmio dati acceso, rete 2G, o dispositivo con pochissima memoria:
     niente animazione decorativa. In tutti gli altri casi si vede. */
  function clienteInDifficolta() {
    try {
      var c = navigator.connection || navigator.webkitConnection || navigator.mozConnection;
      if (c) {
        if (c.saveData) return true;
        if (/^(slow-2g|2g)$/.test(c.effectiveType || '')) return true;
      }
      if (typeof navigator.deviceMemory === 'number' && navigator.deviceMemory > 0 && navigator.deviceMemory <= 2) return true;
    } catch (e) {}
    return false;
  }

  function boot() {
    var intro = document.getElementById('psi-intro');
    if (!intro) return;

    var root = document.documentElement;
    var stage = intro.querySelector('.psi-intro__stage');
    /* Primo frame solo quando P, S, PLANET e SPORT sono gia' decodificate.
       Le copie P/S condividono le stesse URL e non aggiungono download. */
    var allImages = Array.prototype.slice.call(intro.querySelectorAll('img'));
    var sessionKey = intro.getAttribute('data-session-key') || 'psi-intro-viewed';
    var finished = false;
    var revealing = false;
    var started = false;
    var imagesReady = false;
    var resourceTimer, armTimer, revealTimer, hardStopTimer;

    function shouldSkip() {
      try {
        if (intro.getAttribute('data-design-mode') === 'true') return true;
        if (window.location.search.indexOf('customer_posted') !== -1) return true;
        if (window.sessionStorage && window.sessionStorage.getItem(sessionKey) === '1') return true;
      } catch (error) {}
      if (clienteInDifficolta()) return true;
      return false;
    }

    function clearTimers() {
      if (resourceTimer) window.clearTimeout(resourceTimer);
      if (armTimer) window.clearTimeout(armTimer);
      if (revealTimer) window.clearTimeout(revealTimer);
      if (hardStopTimer) window.clearTimeout(hardStopTimer);
    }

    function finish() {
      if (finished) return;
      finished = true;
      clearTimers();
      document.removeEventListener('visibilitychange', tryPlay);
      root.classList.remove('psi-intro-playing', 'psi-intro-defer', 'psi-cookie-hold');
      if (intro.parentNode) intro.remove();
    }

    function decodeImage(image) {
      if (image.decode) return image.decode();
      if (image.complete && image.naturalWidth > 0) return Promise.resolve();
      return new Promise(function (resolve, reject) {
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', reject, { once: true });
      });
    }

    function reveal(skip) {
      if (revealing || finished) return;
      revealing = true;
      /* Durante la corsa il sito si vede per intero, quindi le sezioni sotto
         la prima vanno disegnate ORA: se restassero rimandate si vedrebbe la
         pagina montarsi a pezzi dentro la dissolvenza. */
      root.classList.remove('psi-intro-playing', 'psi-intro-defer');
      intro.classList.add('is-armed', 'is-revealing');
      if (skip) intro.classList.add('is-skip');
    }

    function play() {
      if (started || finished) return;
      started = true;
      document.removeEventListener('visibilitychange', tryPlay);

      try {
        if (window.sessionStorage) window.sessionStorage.setItem(sessionKey, '1');
      } catch (error) {}

      intro.classList.add('is-ready');

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (finished) return;
          intro.classList.add('is-playing');
          armTimer = window.setTimeout(function () {
            intro.classList.add('is-armed');
          }, PLAY_TO_ARM);
          revealTimer = window.setTimeout(function () {
            reveal(false);
          }, PLAY_TO_REVEAL);
          hardStopTimer = window.setTimeout(finish, HARD_STOP_DA_PLAY);
        });
      });
    }

    function armResourceTimer() {
      if (resourceTimer || finished || started || imagesReady || document.hidden) return;
      resourceTimer = window.setTimeout(function () {
        resourceTimer = null;
        if (!imagesReady && !started && !document.hidden) finish();
      }, RESOURCE_TIMEOUT);
    }

    /* La preview desktop puo' nascere in background. Le immagini si preparano
       subito, ma i 2710 ms della coreografia partono soltanto in primo piano. */
    function tryPlay() {
      if (finished || started) return;
      if (document.hidden) {
        if (resourceTimer) window.clearTimeout(resourceTimer);
        resourceTimer = null;
        return;
      }
      if (!imagesReady) {
        armResourceTimer();
        return;
      }
      if (resourceTimer) window.clearTimeout(resourceTimer);
      resourceTimer = null;
      play();
    }

    if (shouldSkip()) {
      finish();
      return;
    }

    root.classList.add('psi-cookie-hold', 'psi-intro-playing', 'psi-intro-defer');

    stage.addEventListener('animationend', function (event) {
      if (event.animationName === 'psiPush') finish();
    });

    allImages.forEach(function (image) {
      image.addEventListener('error', finish, { once: true });
    });

    document.addEventListener('visibilitychange', tryPlay);

    Promise.all(allImages.map(decodeImage)).then(function () {
      if (finished || started) return;
      imagesReady = true;
      tryPlay();
    }).catch(finish);

    tryPlay();

    intro.addEventListener('click', function () {
      if (finished) return;
      if (!started) {
        finish();
        return;
      }
      reveal(true);
      window.setTimeout(finish, 500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
